import { Components } from '@mui/material';

import variants from 'components/table/variants';

import { colors } from 'theme/colors';
import typography from 'theme/typography';

const tableBody: Components['MuiTableBody'] = {
  styleOverrides: {
    root: {
      '& .MuiTableCell-root': {
        color: colors.border.dark,
        fontSize: typography.caption1_Regular.fontSize,
        borderBottom: `1px solid ${colors.cards.light}`,
        textAlign: 'left',
        padding: '20px 16px !important',

        [`&.${variants.tbody.highlight}`]: {
          background: colors.background.dark,
        },

        [`&.${variants.tbody.withBackground}`]: {},

        [`&.${variants.tbody['paddingBottom-10']}`]: {
          paddingBottom: '10px',
        },
      },
      '& .MuiTableRow-root': {
        background: colors.background.light,
      },
      '& .MuiButtonBase-root': {
        padding: '0 !important',
      },

      '& .MuiTypography-root': {
        lineHeight: '32px !important',
      },
    },
  },
};

export default tableBody;
